import classNames from 'classnames'
import useIsMobile from '../../../modules/hooks/common/useIsMobile'
import useIsWebview from '../../../modules/hooks/common/useIsWebview'
import MaterialInsightBody from './MaterialInsightBody'
import MediaPanel from './MediaPanel'
import QuestionPanel from './QuestionPanel'

interface IMaterialBodyComponent {
  activeTabIdx: number
  materialData?
  materialId: any
  isInsightButton?: boolean
  isModal?: boolean
  setShowNav?: any
}

const NEW_TAB = {
  INSIGHT: 0,
  QUESTIONS: 1,
  MEDIA: 2,
  EXPRESSIONS: 3,
}

const MaterialBodyComponent = ({
  activeTabIdx,
  materialData,
  materialId,
  isModal = false,
  setShowNav,
}: IMaterialBodyComponent) => {
  const isWebview = useIsWebview()
  const isMobile = useIsMobile()
  const media = {
    youtubes: materialData?.course.video,
    articles: materialData?.course.article,
  }

  const noMedia = media.youtubes?.length == 0 && media.articles?.length == 0

  switch (activeTabIdx) {
    case NEW_TAB.INSIGHT:
      return (
        <MaterialInsightBody
          materialData={materialData}
          materialId={materialId}
          isModal={isModal}
          setShowNav={setShowNav}
        />
      )
    case NEW_TAB.QUESTIONS:
      return (
        <div className={classNames((isWebview || isMobile) && 'px-[16px]')}>
          <QuestionPanel id={materialId} materialData={materialData} />
        </div>
      )
    case NEW_TAB.EXPRESSIONS:
      return (
        <div className={classNames((isWebview || isMobile) && 'px-[16px]')}>
          <QuestionPanel id={materialId} materialData={materialData} />
        </div>
      )
    case NEW_TAB.MEDIA:
      return <MediaPanel media={media} noMedia={noMedia} course={materialData} className="mx-0 max-w-[688px] px-0" />
    default:
      return <MaterialInsightBody materialData={materialData} materialId={materialId} setShowNav={setShowNav} />
  }
}

export default MaterialBodyComponent
